import styled from 'react-emotion';

export const ThreeWrapper = styled('div')`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  position: relative;
  width: 100%;
  height: 100%;
`;
